<template>
  <svg class="plus_ico" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5V19" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M5 12H19" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</template>

<script>
export default {
  name: 'PlusIco'
}
</script>
